import { createSlice } from "@reduxjs/toolkit";

export const stateSlice = createSlice({
  name: "date-birth",
  initialState: {
    aspect: "",
    birthDate: {},
    birthPlace: "",
    birthTime: {},
    gender: "",
    elementOfNature: "",
    relationshipStatus: "",
    traits: [],
    whatDrivesYou: [],
  },
  reducers: {
    setAspect: (state, action) => {
      state.aspect = action.payload;
    },
    setBirthDate: (state, action) => {
      state.birthDate = action.payload;
    },
    setBirthPlace: (state, action) => {
      state.birthPlace = action.payload;
    },
    setBirthTime: (state, action) => {
      state.birthTime = action.payload;
    },
    setGender: (state, action) => {
      state.gender = action.payload;
    },
    setElementOfNature: (state, action) => {
      state.elementOfNature = action.payload;
    },
    setRelationshipStatus: (state, action) => {
      state.relationshipStatus = action.payload;
    },
    setTraits: (state, action) => {
      state.traits = action.payload;
    },
    setWhatDrivesYou: (state, action) => {
      state.whatDrivesYou = action.payload;
    },
  },
});

export const {
  setAspect,
  setBirthDate,
  setBirthPlace,
  setBirthTime,
  setGender,
  setElementOfNature,
  setRelationshipStatus,
  setTraits,
  setWhatDrivesYou,
} = stateSlice.actions;

export default stateSlice.reducer;
